(function () {
  function initFeaturedProducts(section) {
    var swiperEl = section.querySelector('[data-landing-featured-products-swiper]');

    if (!swiperEl || typeof Swiper === 'undefined') {
      return;
    }

    if (swiperEl.swiper) {
      swiperEl.swiper.destroy(true, true);
    }

    var autoplayEnabled = section.getAttribute('data-autoplay') === 'true';
    var autoplayInterval = Number(section.getAttribute('data-autoplay-interval')) || 4000;
    var arrowsEnabled = section.getAttribute('data-arrows') === 'true';
    var prevButton = section.querySelector('[data-landing-featured-products-prev]');
    var nextButton = section.querySelector('[data-landing-featured-products-next]');

    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var config = {
      slidesPerView: 1.35,
      spaceBetween: 20,
      speed: 600,
      watchOverflow: true,
      grabCursor: true,
      loop: false,
      breakpoints: {
        390: {
          slidesPerView: 1.45,
          spaceBetween: 20,
        },
        750: {
          slidesPerView: 2.2,
          spaceBetween: 20,
        },
        990: {
          slidesPerView: 4,
          spaceBetween: 34,
          allowTouchMove: false,
          grabCursor: false,
        },
      },
    };

    if (autoplayEnabled && !prefersReducedMotion) {
      config.autoplay = {
        delay: autoplayInterval,
        disableOnInteraction: true,
        pauseOnMouseEnter: true,
      };
    }

    if (arrowsEnabled && prevButton && nextButton) {
      config.navigation = {
        prevEl: prevButton,
        nextEl: nextButton,
      };
    }

    new Swiper(swiperEl, config);
  }

  function initAllFeaturedProducts() {
    var sections = document.querySelectorAll('[data-landing-featured-products]');

    sections.forEach(function (section) {
      initFeaturedProducts(section);
    });
  }

  document.addEventListener('DOMContentLoaded', initAllFeaturedProducts);

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-landing-featured-products]');

    if (section) {
      initFeaturedProducts(section);
    }
  });
})();
